<template>
  <sp-col cols="6" cols-sm="8">
    <sp-text-field
      v-model="model"
      clearable
      persistent-clear
      placeholder="Enter promo code"
      @input="clearError"
      @keydown.enter.stop="applyPromoCode"
      @clear="resetModel"
    ></sp-text-field>
    <sp-alert v-if="error" type="error" variant="text" compact>
      {{ error }}
    </sp-alert>
  </sp-col>

  <sp-col self-align="center" cols="3" cols-sm="4" no-start-gap>
    <sp-button densitysmcompact="false" :disabled="!promoCodeApplicable" :loading="loading" @click="applyPromoCode">
      Apply
    </sp-button>
  </sp-col>
</template>

<script setup>
import { computed, ref } from "vue";
import { usePurchaseStore } from "#ce/components/SpCheckout/store/purchase";

const purchaseStore = usePurchaseStore();

const model = ref();
const error = ref();
const loading = ref(false);

const promoCodeApplicable = computed(() => model.value && model.value.length >= 3);

async function applyPromoCode() {
  if (loading.value) {
    return;
  }

  loading.value = true;
  error.value = undefined;

  const { error: applyError } = await purchaseStore.applyPromoCode(model.value);
  loading.value = false;
  error.value = applyError;

  if (!applyError) {
    model.value = undefined;
  }
}

function clearError() {
  error.value = undefined;
}

function resetModel() {
  model.value = undefined;
}
</script>
